module.exports = __webpack_public_path__ + "static/media/money-icon.3592b841.svg";